var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-button',{staticClass:"md-raised md-primary",on:{"click":_vm.onSaveClicked}},[_vm._v(" Save ")]),_c('div',{staticClass:"transition-mask",class:{
      'transition-start': _vm.transitionStage === 0,
      'transition-peak': _vm.transitionStage === 1,
      'transition-end': _vm.transitionStage === 2
    },style:({
      transition: ("all ease-in " + _vm.transition + "ms")
    })}),(_vm.transitionStage > 1)?_c('div',{staticClass:"transition-mask-bg"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }